import React, { useState, useEffect } from 'react';
import styles from './index.module.sass';
import { useTranslation } from 'react-i18next';
import Alert from '../Alert';
import superagent from 'superagent';
import { CircularProgress } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
//Dependencies
import buttonFormROP from '../VerifyButtonROP/buttonROP.js';
import usStates from '../Queries/usStates';
import AvalaraResolveAddress from '../Queries/AvalaraResolveAddress.js';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

const RegistrationForm = (props) => {
  const { device, webservice, history } = props;
  const { screenSize } = device;
  const { t } = useTranslation('registrationForm');

  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const [openSucces, setopenSucces] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);
  const [message, setmessage] = useState('');
  const [buttonROP, setButtonROP] = useState(true);
  const [mostrarFormulario, setMostrarFormulario] = useState(true);

  const [loading, setLoading] = useState(false);

  //hooks del formulario
  const [valuesForm, setvaluesForm] = useState({
    name: '',
    lastName: '',
    firstName: '',
    num1: '',
    num2: '',
    dep: '',
    mza: '',
    street: '',
    edifice: '',
    col: '',
    cp: '',
    statement: '',
    town: '',
    phone1: '',
    nacimiento: '',
    mail: '',
    Kit: '',
    Namepatrocinadora: '',
    validado: false,
  });

  const changeValue = (e) => {
    if (e.target.name === 'Kit') {
      e.target.value = e.target.value.replace(
        /[`~´!¡@#$%^&*()_|+\-=¿?;:'",.<>œæ€®†¥øπå∫∂ƒ™¶§≤∑©√ßµ„…–¢∞¬÷“”≠‚ºª·ç¨Ωñ{}abcdefghijklmnopqrstuvwxyz[\]\\/ ]/gi,
        '',
      );
    }
    setvaluesForm({
      ...valuesForm,
      [e.target.name]: e.target.value,
    });
  };

  function restrictChars($event) {
    if ($event.charCode === 0 || /\d/.test(String.fromCharCode($event.charCode))) {
      return true;
    } else {
      $event.preventDefault();
    }
  }

  async function Save() {
    setLoadingForm(true);
    const response = await buttonFormROP();
    if (response === '') {
      setAlertText('El tiempo se ha terminado, no es posible completar el registro');
      setOpen(true);
      setLoadingForm(true);
      setTimeout(() => {
        history.push('/');
      }, 4000);
      return;
    } else {
      if (valuesForm.name === '') {
        setAlertText(t('nameToRegister'));
        setOpen(true);
        setLoadingForm(false);
        return;
      }

      // if (valuesForm.lastName === '') {
      //   setAlertText(t('lastNameToRegister'));
      //   setOpen(true);
      //   setLoadingForm(false);
      //   return;
      // }

      if (valuesForm.street === '') {
        setAlertText(t('streetToRegister'));
        setOpen(true);
        setLoadingForm(false);
        return;
      }

      if (valuesForm.cp === '') {
        setAlertText(t('cpToRegister'));
        setOpen(true);
        setLoadingForm(false);
        return;
      }
      // if (valuesForm.col === '') {
      //   setAlertText(t('colToRegister'));
      //   setOpen(true);
      //   setLoadingForm(false);
      //   return;
      // }
      if (valuesForm.statement === '') {
        setAlertText(t('statementToRegister'));
        setOpen(true);
        setLoadingForm(false);
        return;
      }
      if (valuesForm.town === '') {
        setAlertText(t('townToRegister'));
        setOpen(true);
        setLoadingForm(false);
        return;
      }

      if (valuesForm.mail === '') {
        setAlertText(t('mailToRegister'));
        setOpen(true);
        setLoadingForm(false);
        return;
      }

      if (valuesForm.phone1 === '') {
        setAlertText(t('phone1ToRegister'));
        setOpen(true);
        setLoadingForm(false);
        return;
      }

      if (valuesForm.phone1.length < 10) {
        setAlertText(t('phoneCharacteres'));
        setOpen(true);
        setLoadingForm(false);
        return;
      }

      if (valuesForm.nacimiento === '') {
        setAlertText('Favor de escribir tu fecha de nacimiento');
        setOpen(true);
        setLoadingForm(false);
        return;
      }

      sendForm();
    }
    setLoadingForm(false);
  }

  function sendForm() {
    setLoadingForm(true);
    const json = {
      idRop: buttonROP,
      nombres: valuesForm.name,
      apellidoPaterno: valuesForm.lastName,
      apellidoMaterno: valuesForm.firstName,
      line1: valuesForm.street,
      line2: '',
      line3: '',
      noExt: valuesForm.num1,
      noInt: valuesForm.num2,
      colonia: '',
      ciudad: valuesForm.town,
      estado: valuesForm.statement,
      codigoPostal: valuesForm.cp,
      correo: valuesForm.mail.toLowerCase(),
      celular: valuesForm.phone1,
      noKit: valuesForm.Kit,
      fechaNacimiento: valuesForm.nacimiento,
      nombreConsultora: valuesForm.Namepatrocinadora,
    };

    superagent
      .post(`${webservice}/USA/ROP/ROP`)
      .send(json)
      .then((response) => {
        const { codigoMensaje, mensajeEsp } = response.body;
        if (codigoMensaje !== 200) {
          setLoadingForm(false);
          setmessage(mensajeEsp);
          setAlertText(mensajeEsp);
          setOpen(true);
        } else {
          // setAlertText('Registrada con éxito');
          // setOpen(true);
          setmessage('Tú registro se ha realizado con éxito');
          localStorage.setItem('registroRop', 'true');

          // Ocultar el formulario
          setMostrarFormulario(false);
          setLoadingForm(false);
          setopenSucces(true);
        }
      })
      .catch((Err) => {
        alert('Error');
        console.log(Err);
      });
  }

  async function verifyAddress() {
    setLoading(true);
    const resp = await AvalaraResolveAddress({
      jsonBody: {
        line1: valuesForm.street,
        line2: '',
        city: valuesForm.city,
        region: valuesForm.statement,
        postalCode: valuesForm.cp,
        country: 'US',
      },
    });

    const { message = '', tipoMensaje, validatedAddresses = [] } = resp;
    const { addressType = '' } = validatedAddresses[0] || {};

    if (tipoMensaje === 'success' && addressType !== 'POBoxAddress' && validatedAddresses[0]) {
      const { city, line1, line2, region, postalCode } = validatedAddresses[0];

      setvaluesForm({
        ...valuesForm,
        validado: true,
        street: line1,
        // entreCalle: line2,
        statement: region,
        town: city,
        cp: postalCode,
      });
      // }
    } else if (addressType === 'POBoxAddress') {
      setAlertText('PO BOX addresses are not allowed');
      setOpen(true);
    } else if (tipoMensaje === 'inspect') {
      setAlertText(message);
      setOpen(true);
      setvaluesForm({
        ...valuesForm,
        validado: false,
      });
    } else {
      if (message) setAlertText(message);
      else setAlertText('Validation error');

      setOpen(true);
      setvaluesForm({
        ...valuesForm,
        validado: false,
      });
    }

    setLoading(false);
  }

  useEffect(() => {
    const registroRealizado = localStorage.getItem('registroRop');

    if (registroRealizado === 'true') {
      setMostrarFormulario(false);
    } else {
      setMostrarFormulario(true);
    }
  }, []);

  useEffect(() => {
    async function loadROP() {
      const response = await buttonFormROP();
      setButtonROP(response);
      if (buttonROP === false) {
        history.push('/');
      }
    }
    loadROP();
  }, [buttonROP, history]);

  return (
    <div>
      <div className={styles.return}>
        <div className={styles.buttonsReturn}>
          <label onClick={() => history.push('/')} className={styles.labelReturn}>
            Regresar
          </label>
        </div>
      </div>
      <div className={styles[screenSize]} id={styles.RegistrationForm}>
        <Alert open={open} setOpen={setOpen} title={t('messageTitleAlert')} text={alertText} />
        <Dialog
          open={openSucces}
          TransitionComponent={Transition}
          keepMounted
          //onClose={return}
          aria-labelledby='alert-dialog-slide-title'
          aria-describedby='alert-dialog-slide-description'>
          <DialogTitle id='alert-dialog-slide-title'>Aviso</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-slide-description'>{message}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => history.push('/')} color='primary'>
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>

        {mostrarFormulario ? (
          <div className={styles.container}>
            <h5>{t('h5Personal')}</h5>

            <div className={styles.personalInformation}>
              <div className={styles.subItem}>
                <span>
                  <label htmlFor=''>Nombre*</label>
                  <input
                    type='text'
                    name='name'
                    value={valuesForm.name}
                    autoComplete='off'
                    onChange={(e) => changeValue(e)}
                    maxLength='45'
                  />
                </span>
              </div>

              <div className={styles.subItem}>
                <span>
                  <label htmlFor=''>Apellidos*</label>
                  <input
                    type='text'
                    name='lastName'
                    value={valuesForm.lastName}
                    onChange={(e) => changeValue(e)}
                    autoComplete='off'
                    maxLength='45'
                  />
                </span>
              </div>

              {/* <div className={styles.subItem}>
              <span>
                <label htmlFor=''>{t('firstName')}</label>
                <input
                  type='text'
                  name='firstName'
                  value={valuesForm.firstName}
                  onChange={(e) => changeValue(e)}
                  autoComplete='off'
                  maxLength='45'
                />
              </span>
            </div> */}
            </div>

            <h5>{t('h5Address')}</h5>

            <div className={styles.address}>
              <div className={styles.subItem}>
                <span>
                  <label htmlFor=''>Direccion*</label>
                  <input
                    type='text'
                    name='street'
                    value={valuesForm.street}
                    onChange={(e) => changeValue(e)}
                    autoComplete='off'
                    maxLength='30'
                  />
                </span>
              </div>

              <div className={styles.subItem}>
                <span>
                  <label htmlFor=''>{t('cp')}*</label>
                  <input
                    type='text'
                    name='cp'
                    autoComplete='off'
                    placeholder='00000'
                    maxLength='5'
                    onKeyPress={(e) => restrictChars(e)}
                    onChange={(e) => changeValue(e)}
                    value={valuesForm.cp}
                  />
                </span>
              </div>

              <div className={styles.subItem}>
                <label htmlFor=''>Verifica tu domicilio*</label>
                <div>
                  <Button
                    type='submit'
                    variant='contained'
                    size='large'
                    color='primary'
                    className={`${styles.button}`}
                    onClick={() => {
                      if (!loading) verifyAddress();
                    }}>
                    {(loading && <CircularProgress className={styles.circularProgress} />) || (
                      <span className={styles.buttonText}>Validar</span>
                    )}
                  </Button>
                </div>

                <div className={`${styles.verifyText} ${styles[valuesForm?.validado]}`}>
                  <i className={`material-icons-outlined ${styles.validateIcon}`}>
                    {(valuesForm?.validado === true && 'check_circle') || 'cancel'}
                  </i>
                  {(valuesForm?.validado === true && 'La dirección ha sido validada') ||
                    'La dirección no ha sido validada'}
                </div>
              </div>

              {/* <div className={styles.subItem}>
              <span>
                <label htmlFor=''>{t('num1')}</label>
                <input
                  type='text'
                  name='num1'
                  value={valuesForm.num1}
                  onChange={(e) => changeValue(e)}
                  autoComplete='off'
                  maxLength='40'
                />
              </span>
            </div>

            <div className={styles.subItem}>
              <span>
                <label htmlFor=''>{t('num2')}</label>
                <input
                  type='text'
                  name='num2'
                  value={valuesForm.num2}
                  onChange={(e) => changeValue(e)}
                  autoComplete='off'
                  maxLength='40'
                />
              </span>
            </div> */}
            </div>

            {/* <div className={styles.address}>
            <div className={styles.subItem}>
              <span>
                <label htmlFor=''>{t('dep')}</label>
                <input
                  type='text'
                  name='dep'
                  value={valuesForm.dep}
                  onChange={(e) => changeValue(e)}
                  autoComplete='off'
                  maxLength='40'
                />
              </span>
            </div>

            <div className={styles.subItem}>
              <span>
                <label htmlFor=''>{t('mza')}</label>
                <input
                  type='text'
                  name='mza'
                  value={valuesForm.mza}
                  onChange={(e) => changeValue(e)}
                  autoComplete='off'
                  maxLength='40'
                />
              </span>
            </div>

            <div className={styles.subItem}>
              <span>
                <label htmlFor=''>{t('edifice')}</label>
                <input
                  type='text'
                  name='edifice'
                  value={valuesForm.edifice}
                  onChange={(e) => changeValue(e)}
                  autoComplete='off'
                  maxLength='40'
                />
              </span>
            </div>
          </div> */}

            <div className={styles.address}>
              <div className={styles.subItem}>
                <span>
                  <label htmlFor=''>Estado*</label>

                  <select
                    className={styles.select}
                    name='statement'
                    onChange={(e) => changeValue(e)}
                    value={valuesForm.statement}>
                    <option value=''>Selecciona tu estado</option>
                    {usStates.map((val, key) => {
                      const { code = '', name = '' } = val;
                      return (
                        <option value={code} key={key}>
                          {name}
                        </option>
                      );
                    })}
                  </select>
                </span>
              </div>

              <div className={styles.subItem}>
                <span>
                  <label htmlFor=''>Ciudad*</label>
                  <input
                    type='text'
                    autoComplete='off'
                    value={valuesForm.town}
                    onChange={(e) => changeValue(e)}
                    name='town'
                  />
                </span>
              </div>

              {/* <div className={styles.subItem}>
              <span>
                <label htmlFor=''>{t('statement')}</label>
                <input
                  type='text'
                  autoComplete='off'
                  disabled
                  value={valuesForm.statement}
                  onChange={(e) => changeValue(e)}
                  maxLength='30'
                />
              </span>
            </div> */}
            </div>

            <h5>{t('h5contact')}</h5>

            <div className={styles.contact}>
              <div className={styles.subItem}>
                <span>
                  <label htmlFor=''>{t('mail')}*</label>
                  <input
                    type='text'
                    name='mail'
                    autoComplete='off'
                    placeholder='example@terramar.com'
                    onChange={(e) => changeValue(e)}
                    value={valuesForm.mail}
                    maxLength='50'
                  />
                </span>
              </div>

              <div className={styles.subItem}>
                <span>
                  <label htmlFor=''>{t('cel')}*</label>
                  <input
                    type='text'
                    name='phone1'
                    autoComplete='off'
                    placeholder='(00) 00000000'
                    maxLength='10'
                    onKeyPress={(e) => restrictChars(e)}
                    onChange={(e) => changeValue(e)}
                    value={valuesForm.phone1}
                  />
                </span>
              </div>

              <div className={styles.subItem}>
                <span>
                  <label htmlFor=''>Fecha de Nacimiento*</label>
                  <input
                    type='date'
                    name='nacimiento'
                    onChange={(e) => changeValue(e)}
                    value={valuesForm.nacimiento}
                  />
                </span>
              </div>
            </div>

            <h5>
              Si fuiste invitada por alguna consultora o líder ingresa el número de KIT y Nombre
            </h5>

            <div className={styles.contact}>
              <div className={styles.itemKit}>
                <span>
                  <label htmlFor=''>{t('kit')}</label>
                  <input
                    type='text'
                    name='Kit'
                    autoComplete='off'
                    onChange={(e) => changeValue(e)}
                    value={valuesForm.Kit}
                    maxLength='7'
                  />
                </span>
              </div>
              <div className={styles.itemKit}>
                <span>
                  <label htmlFor=''>Nombre </label>
                  <input
                    type='text'
                    name='Namepatrocinadora'
                    autoComplete='off'
                    onChange={(e) => changeValue(e)}
                    value={valuesForm.Namepatrocinadora}
                  />
                </span>
              </div>
            </div>

            <div className={styles.buttonsContainer}>
              {(!loadingForm && valuesForm.validado && (
                <Button
                  type='submit'
                  variant='contained'
                  size='large'
                  color='primary'
                  className={`${styles.button}`}
                  onClick={() => {
                    if (loadingForm) return;
                    else Save();
                  }}>
                  {(loadingForm && <CircularProgress />) || t('buttonSave')}
                </Button>
              )) || (
                <div>
                  <Button
                    type='submit'
                    variant='contained'
                    size='large'
                    color='primary'
                    className={`${styles.buttonDisabled}`}>
                    Cargando
                  </Button>
                </div>
              )}
            </div>
            <br />
          </div>
        ) : (
          <div className={styles.yaRegistrado}>
            Ya hemos registrado tu información, gracias por seguir la Transmisión.
          </div>
        )}
      </div>
    </div>
  );
};

export default RegistrationForm;
